import * as ng from 'angular';
import { UtilsService } from '../utils.service';

export class InfotipController {
   static $inject = ['$transclude', '$templateCache', '$timeout', 'utils'];

   constructor(
      private $transclude:ng.ITranscludeFunction,
      private $templateCache:ng.ITemplateCacheService,
      private $timeout:ng.ITimeoutService,
      utils:UtilsService
   ) {
      this.templateId = utils.generateUniqueId();
   }

   templateId:string;
   placement:string;
   isOpen = false;
   isLocked = false;
   timeoutId:ng.IPromise<void> = null;

   $onInit() {
      this.$transclude((cloned:JQLite) => {
         // wrapping the cloned elements since html() returns innerHTML
         let html = ng.element('<div>').append(cloned).html();

         // wrapping tooltip content lets us add logic to keep tooltip open
         html = `<div ng-mouseenter="$ctrl.isLocked=true" ng-mouseleave="$ctrl.isLocked=false">${html}</div>`;

         this.$templateCache.put(this.templateId, html);
      });
   }

   show() {
      if (this.timeoutId) {
         this.$timeout.cancel(this.timeoutId);
         this.timeoutId = null;
      }

      this.isOpen = true;
   }

   hide() {
      this.timeoutId = this.$timeout(() => {
         this.timeoutId = null;

         if (this.isLocked) {
            this.hide();
         } else {
            this.isOpen = false;
         }
      }, 1000);
   }
}

ng.module('e360').component('infotip', {
   template: `<i class="fa fa-info-circle infotip"
      uib-tooltip-template="$ctrl.templateId"
      tooltip-append-to-body="true"
      tooltip-is-open="$ctrl.isOpen"
      tooltip-placement="{{::$ctrl.placement}}"
      tooltip-trigger="'none'"
      ng-mouseenter="$ctrl.show()"
      ng-mouseleave="$ctrl.hide()">
   </i>`,
   controller: InfotipController,
   transclude: true,
   bindings: {
      placement: '@'
   }
});
